import React from 'react';
import { CurlySeduccion } from './pages/CurlySeduccion';
type AppProps = {
  showStickyCta?: boolean;
  debugPixel?: boolean;
};
export function App({
  showStickyCta = true,
  debugPixel = false
}: AppProps) {
  return <CurlySeduccion showStickyCta={showStickyCta} debugPixel={debugPixel} data-id="element-0" data-mp="3k8jhzgoph0nl" />;
}